module.exports = __webpack_public_path__ + "img/cardread-hand.e56e94c9.jpg";